export const REPORT_VIEW_PAGE = "view";
